import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User initiated an ad import',
  name: 'ad_import_initiated',
};

export default META;
